import { type ReactElement } from 'react';

import { Container, Typography, Link } from '@mui/material';

export default function ErrorFallback(): ReactElement {
  return (
    <Container component="main" maxWidth="md" sx={{ placeContent: 'center' }}>
      <Typography variant="h1" component="h1" sx={{ mx: 'auto' }}>
        Oops! Something Went Wrong
      </Typography>
      Hmm... something seems to have gone awry on our website. But don&apos;t worry,
      we&apos;ve got your back! Here are a few options to get back on track:
      <ul>
        <li>
          Try
          {' '}
          <Link
            href=""
            sx={{
              color: '#1c75ba',
              textDecoration: 'none',
              '&:hover': { color: '#1c75ba', textDecoration: 'underline' },
            }}
          >
            reloading
          </Link>
          {' '}
          the page and giving it another go. Sometimes technology just needs a little nudge. Or, why not start fresh
          from our
          {' '}
          <Link
            href="/"
            sx={{
              color: '#1c75ba',
              textDecoration: 'none',
              '&:hover': { color: '#1c75ba', textDecoration: 'underline' },
            }}
          >
            homepage
          </Link>
          ? It&apos;s the perfect place to discover the charting wonders of our Qlik Sense extensions!
        </li>
        <li>
          If you&apos;re still having trouble, please don&apos;t hesitate to shoot us an email at&nbsp;
          <Link
            href="mailto:support@anychart.com"
            sx={{
              color: '#1c75ba',
              textDecoration: 'none',
              '&:hover': { color: '#1c75ba', textDecoration: 'underline' },
            }}
          >
            support@anychart.com
          </Link>
          . We&apos;ll do our best to help you get back on track!
        </li>
      </ul>
    </Container>
  );
}
